import React from 'react';
import './CounselingRoom1.css';
import heroImg from './assets/counselling1.jpg';

const CounselingRoom1 = () => {
  return (
    <div className="counseling-room-page">

      {/* Hero Section */}
      <div className="hero-section">
        <img src={heroImg} alt="Counseling Room" className="hero-image" />
        <div className="overlay">
          <h1>Welcome to Counseling Room 1</h1>
          <p>Your journey to personalized care and professional support begins here.</p>
        </div>
      </div>

      {/* Video Section */}
      <section className="video-section">
        <h2>🎥 Inside Counseling Room 1</h2>
        <p className="video-caption">
          Watch this short video by our nurse explaining what to expect during your session in Counseling Room 1.
        </p>
        <div className="video-wrapper">
          <video
            controls
            playsInline
            preload="metadata"
            className="counseling-video"
          >
            <source
              src="https://res.cloudinary.com/dfbgpqygq/video/upload/v1751303217/video1_mpncic.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <h2>🧠 Frequently Asked Questions (FAQs)</h2>
        <ul className="faq-list">
          <li>
            <span className="faq-question">What happens in Counseling Room 1?</span><br />
            <span className="faq-answer">
              <ol>
                <li>Taking your weight</li>
                <li>Measuring your waist circumference</li>
                <li>Defining what diabetes and hypertension are</li>
                <li>Learning basic laboratory test that diagnose pre-diabetic stage, diabetes (HbA1C and fasting blood sugar), risk of heart attack & stroke (cholesterol), if kidneys are affected ( kidney test and urine test) and if heart affected (ECG)</li>
              </ol>
            </span>
          </li>

          <li>
            <span className="faq-question">Do I need to prepare before coming?</span><br />
            <span className="faq-answer">No preparation is needed. Just come relaxed and ready for a short discussion.</span>
          </li>

          <li>
            <span className="faq-question">Why is high blood pressure considered a silent killer?</span><br />
            <span className="faq-answer">It has no obvious symptoms until serious complications like stroke or heart failure occur.</span>
          </li>

          <li>
            <span className="faq-question">What are the signs to watch for that a patient might have diabetes?</span><br />
            <span className="faq-answer">Excessive thirst, urination, fatigue, weight loss, constant hunger, and vision loss. These other signs may appear 5 -7 years after onset of high blood sugar in your blood. Uncontrolled high blood sugar meanwhile are damaging your kidneys, blood vessels, eyes, nerves etc. Thus first sign of diabetes may be loss of vision! So do blood sugar test, save your life.</span>
          </li>

          <li>
            <span className="faq-question">Why is cholesterol value assessed?</span><br />
            <span className="faq-answer">To assess your risk of heart attack and stroke.  We call cholesterol an enemy of diabetes and hypertension.</span>
          </li>
        </ul>
      </section>

    </div>
  );
};

export default CounselingRoom1;
